import React, { Fragment } from 'react';
import { List, Item } from 'semantic-ui-react';

import parseServerChangeLog from './parseServerLog';

const TaskList = ({ details }) => {
  const tasks = parseServerChangeLog(details);
  const tasksArray = Object.keys(tasks);

  return (
    <Fragment>
      <b>Task{`${tasksArray.length > 1 ? 's' : ''}`}:</b>
      <List size="small" bulleted>
        {tasksArray.map(key => (
          <List.Item key={key}>
            <List.Content style={{ paddingLeft: '1em' }}>
              <Item>
                id: {key}
                <br />
                Task Type: {tasks[key]}
                <br />
                <br />
              </Item>
            </List.Content>
          </List.Item>
        ))}
      </List>
    </Fragment>
  );
};

export default TaskList;



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimHistory/HistoryItem/ActionTypes/TaskList.js